var path = 'app/scripts/modules/dcos/serverGroup/configure/wizard/labels.html';
var html = "<ng-form name=\"labels\" novalidate>\n  <div class=\"container-fluid form-horizontal\">\n    <div class=\"form-group\">\n      <h5 class=\"col-sm-12\">\n        Attach metadata to services to expose additional information to other services.\n      </h5>\n      <div class=\"col-sm-12\">\n        <map-editor model=\"command.labels\" allow-empty=\"true\"></map-editor>\n      </div>\n    </div>\n  </div>\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/serverGroup/configure/wizard/labels.html
// module id = 1751
// module chunks = 0